import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "@/components/landing/Navbar";
import { KineticHero } from "@/components/landing/KineticHero";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { ManifestoChapters } from "@/components/landing/ManifestoChapters";
import { Showcase } from "@/components/landing/Showcase";
import { Benefits } from "@/components/landing/Benefits";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Pricing } from "@/components/landing/Pricing";
import { Testimonials } from "@/components/landing/Testimonials";
import { Faq } from "@/components/landing/Faq";
import { WaitlistSection } from "@/components/landing/WaitlistSection";
import { Footer } from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, wheelMultiplier: 1 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -80, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="grain relative min-h-screen bg-[#0A0A0C] text-slate-100">
      <Navbar />
      <main>
        <KineticHero />
        <EditorialMarquee />
        <ManifestoChapters />
        <Showcase />
        <Benefits />
        <HowItWorks />
        <Pricing />
        <Testimonials />
        <Faq />
        <WaitlistSection />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" richColors />
    </div>
  );
}

export default App;
